const $ = jQuery.noConflict();

'use strict';
const FormScrollError = {
/**
 * @description Cache dom and strings
 * @type {object}
 */

	$domInputTextarea: $('.wpcf7-form input, .wpcf7-form textarea'),

	/** @description Initialize */
	init: function() {
		this.errorScrollTo();
		this.formAutofill();
	},

	errorScrollTo: function() {
		document.addEventListener('wpcf7invalid', function() {
			setTimeout(function() {
				$('html').stop().animate({
					scrollTop: $('.wpcf7-not-valid').eq(0).offset().top - 180,
				}, 500, 'swing');
			}, 100);
		}, false);
	},

	formAutofill: function() {
		FormScrollError.$domInputTextarea.attr('autocomplete', 'negative');
	}

};

export default FormScrollError;